import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { cueClose, cueNavigationCircle, IconComponent } from '@cue/ui/icons';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@cue/ui';
import { ChangeAreaSourceEnum, RequestAreaChangeData } from '@cue/data';
import { LocalizedStringPipe } from '@cue/utilities';

@Component({
  selector: 'cue-navigation-in-progress',
  imports: [IconComponent, TranslocoPipe, ButtonComponent, LocalizedStringPipe],
  templateUrl: './navigation-in-progress.component.html',
  styleUrl: './navigation-in-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationInProgressComponent {
  changeAreaSourceEnum = ChangeAreaSourceEnum;
  ICONS = {
    cueNavigationCircle,
    cueClose,
  };
  close = output();
  changeRoute = output();
  continueRouteWithSpecificGroupIdx = output<number>();
  requestChangeStartResourceId = output<number>();
  requestChangeStartQrCodeId = output<string>();
  requestChangeTargetResourceId = output<number>();
  requestChangeTargetQrCodeId = output<string>();

  requestAreaChangeData = input<RequestAreaChangeData>(null);
  isKiosk = input<boolean>(false);

  protected readonly translation = translation;

  setAsStart() {
    if (this.requestAreaChangeData().requestNewResource) {
      this.requestChangeStartResourceId.emit(this.requestAreaChangeData().requestNewResource);
    } else {
      this.requestChangeStartQrCodeId.emit(this.requestAreaChangeData().requestNewPOI);
    }
  }

  setAsTarget() {
    if (this.requestAreaChangeData().requestNewResource) {
      this.requestChangeTargetResourceId.emit(this.requestAreaChangeData().requestNewResource);
    } else {
      this.requestChangeTargetQrCodeId.emit(this.requestAreaChangeData().requestNewPOI);
    }
  }
}
